/** Assigns window.Theme from #theme-data (see snippets/scripts.liquid). */
(function () {
  var el = document.getElementById('theme-data');
  if (!el) return;
  try {
    window.Theme = JSON.parse(el.textContent);
  } catch (e) {
    /* ignore */
  }
})();
